/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserProvisionResult } from './UserProvisionResult';
import {
    UserProvisionResultFromJSON,
    UserProvisionResultFromJSONTyped,
    UserProvisionResultToJSON,
    UserProvisionResultToJSONTyped,
} from './UserProvisionResult';

/**
 * Response for bulk user provisioning operation
 * @export
 * @interface BulkUserProvisionResponse
 */
export interface BulkUserProvisionResponse {
    /**
     * Whether the bulk operation was successful overall
     * @type {boolean}
     * @memberof BulkUserProvisionResponse
     */
    success?: boolean;
    /**
     * Total number of users processed
     * @type {number}
     * @memberof BulkUserProvisionResponse
     */
    totalProcessed?: number;
    /**
     * Number of users successfully created
     * @type {number}
     * @memberof BulkUserProvisionResponse
     */
    successCount?: number;
    /**
     * Number of users that failed to create
     * @type {number}
     * @memberof BulkUserProvisionResponse
     */
    failureCount?: number;
    /**
     * Number of users skipped (already exist)
     * @type {number}
     * @memberof BulkUserProvisionResponse
     */
    skippedCount?: number;
    /**
     * Detailed results for each user
     * @type {Array<UserProvisionResult>}
     * @memberof BulkUserProvisionResponse
     */
    results?: Array<UserProvisionResult>;
    /**
     * Error message if the entire operation failed
     * @type {string}
     * @memberof BulkUserProvisionResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the BulkUserProvisionResponse interface.
 */
export function instanceOfBulkUserProvisionResponse(value: object): value is BulkUserProvisionResponse {
    return true;
}

export function BulkUserProvisionResponseFromJSON(json: any): BulkUserProvisionResponse {
    return BulkUserProvisionResponseFromJSONTyped(json, false);
}

export function BulkUserProvisionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUserProvisionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'totalProcessed': json['totalProcessed'] == null ? undefined : json['totalProcessed'],
        'successCount': json['successCount'] == null ? undefined : json['successCount'],
        'failureCount': json['failureCount'] == null ? undefined : json['failureCount'],
        'skippedCount': json['skippedCount'] == null ? undefined : json['skippedCount'],
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(UserProvisionResultFromJSON)),
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function BulkUserProvisionResponseToJSON(json: any): BulkUserProvisionResponse {
    return BulkUserProvisionResponseToJSONTyped(json, false);
}

export function BulkUserProvisionResponseToJSONTyped(value?: BulkUserProvisionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'totalProcessed': value['totalProcessed'],
        'successCount': value['successCount'],
        'failureCount': value['failureCount'],
        'skippedCount': value['skippedCount'],
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(UserProvisionResultToJSON)),
        'error': value['error'],
    };
}

